module.exports = __webpack_public_path__ + "img/collaborate_12.458656b0.jpg";